import { dataService } from '../../data';
import { AppConstants } from '@unpispas/upp-defs';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { Place } from './place';
import { DiscountView, DiscountViewProxy } from '../views/discount';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { PlaceType } from '../types';
import { DiscountProductType } from '../types'; 
import { DiscountPeriodType } from '../types';
import { I18nValueType } from '../types';

const _schema = {
    "name": "DISCOUNT",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "place", type: "objid" },
        { name: "name", type: "objid" },
        { name: "type", type: "string" },
        { name: "photo", type: "file" },
        { name: "description", type: "objid" },
        { name: "value", type: "number" },
        { name: "allday", type: "boolean" },
        { name: "allprd", type: "boolean" },
        { name: "cumulative", type: "boolean" }
    ],
    relate: [
        { direction: ">", target: "PLACE", by: "place", name: "place", reason: "place", child: false, class: PlaceType },
        { direction: ">", target: "I18NVALUE", by: "name", name: "name", reason: "name", child: true, class: I18nValueType },
        { direction: ">", target: "I18NVALUE", by: "description", name: "description", reason: "description", child: true, class: I18nValueType },
        { direction: "<", target: "DISCOUNTPRODUCT", by: "discount", name: "product", reason: "products", child: true, class: DiscountProductType },
        { direction: "<", target: "DISCOUNTPERIOD", by: "discount", name: "period", reason: "periods", child: true, class: DiscountPeriodType },
    ]
} as const;

const _DiscountClass = CreateObject(_schema);
if (!_DiscountClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class Discount extends _DiscountClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): Discount {
        return this._Copy(store) as Discount;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'place' && related instanceof Place){
            if (related === this.place){
                related.AddDiscount(this);
            }
        }
    }

    override get viewProxy(): DiscountView {
        return DiscountViewProxy(this, this.data);
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/

    get avatar(): string | null {
        const _bg = 'd3c79b';
        const _fg = '000000';

        const _lb = this.name?.tr() ?? null;
        if (!_lb){
            return null;
        }

        return AppConstants.baseURL + 'photo/avatar?size=128&background=' + _bg + '&color=' + _fg + '&name=' + encodeURIComponent(_lb);
    }

    get photo(): string | null {
        return this['__base__photo'] || this.avatar;
    }

    set photo(value: string | null){
        this['__base__photo'] = value;
    }

    get status(): string | null {
        return this['__base__status']
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.place){
            if ((this.status == 'DE') && !this.Commited){
                this.place.DelDiscount(this);
            }
            else {
                this.place.DoRefresh(this.table);
            }    
        }
    }

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}

